import React from 'react';
import Select from 'react-select';

export const LCReactSelect = props => 
    <Select {...props} />;
